import { createContext, useContext } from 'react';
import { IRouterPage } from '../interfaces/interfaces';

export interface IValidationContextProps {
    invalidFields: (currentPage: IRouterPage) => string[];
}

const ValidationContext = createContext<IValidationContextProps>({} as IValidationContextProps);
export { ValidationContext };
export const useValidationContext = () => useContext(ValidationContext);
